/**
 * Post Event Logg Data
 * @author Abu Sufian
 */
import { get, post } from "axios";


export function postDataToBigQuery(param) {    
    let url = (location.host === 'matcha-jp.com') 
        ? 'https://api.matcha-jp.com/analytics/mediasite/event' 
        : 'https://api-dev.matcha-jp.com/analytics/mediasite/event';
    
    return new Promise((resolve, reject) => {
        post(url, param)
            .then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
    })
}


export function getUserIP() {
    return new Promise((resolve, reject) => {
        let url = `https://extreme-ip-lookup.com/json/`;

        get(url)
            .then(res => {
                // console.log(res);
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
    })
}


// WEBPACK FOOTER //
// ./src/api/event_tracker.js